import { TextV2 } from '@withjoy/joykit';
import React from 'react';
import { Assistance } from '@withjoy/joykit/icons';
import { StayBookingAssistantConfig } from './StayBookingAssistant.config';
import { AdminSidebarComponentProps } from '../JsonComponent.types';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { LayoutAddComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutAddComponentListItem';
import { useTranslation } from '@shared/core';
import { useGoToCreateView } from '../hooks/useJsonComponentNavigation';
import { ComponentType } from '@graphql/generated';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { StayBookingAssistant } from './StayBookingAssistant.types';

export const StayBookingAssistantGrabber = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('stayBookingAssistant');

  return (
    <SimpleGrabHandle
      title={tq`Booking Assistant`}
      icon={<Assistance size={32} />}
      {...props}
    />
  );
};

export const StayBookingAssistantAdd = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('stayBookingAssistant');
  const { goToCreateView } = useGoToCreateView();
  const eventInfo = useEventInfo();
  const eventId = eventInfo?.eventInfo?.eventId;

  const handleClick = useEventCallback(() => {
    // Create empty initial content matching the JSON schema structure
    const content: Partial<StayBookingAssistant> = {};

    goToCreateView({
      id: props.componentData.id,
      containerContent: {
        id: props.containerId,
        type: StayBookingAssistantConfig.componentType,
        content,
        eventId: eventId || '',
        schemaUrl: StayBookingAssistantConfig.schemaUrl,
      },
      type: ComponentType.jsonDataBlob,
      sortOrder: props.componentData?.sortOrder,
      jsonDataContainerId: props.containerId,
      __typename: 'JsonDataBlobComponent',
    });
  }, [props.componentData.id, props.containerId, props.componentData?.sortOrder, eventId, goToCreateView]);

  return (
    <LayoutAddComponentListItem onClick={handleClick}>
      <Assistance size={48} />
      <TextV2
        typographyVariant="hed2"
        textAlign="left"
      >
        {tq`Booking Assistant`}
      </TextV2>
    </LayoutAddComponentListItem>
  );
};
